import React from 'react';
import { useSessionExpiryInterceptor } from './api';

/**
 * Handles global session expiry logic (logout, toast, redirect) on 401/403 errors.
 * Should be rendered inside all required providers (ToastProvider, AuthProvider).
 */
const SessionExpiryHandler: React.FC = () => {
  useSessionExpiryInterceptor();
  return null;
};

export default SessionExpiryHandler;
